import { getCookies } from "./Utility";
import axios from "./axios";

export const downloadFile = async (id: number) => {
  try {
    const tenant_id = getCookies("tenant-id");
    const response = await axios.get(`tenants/${tenant_id}/terms-of-use/${id}/download?project_id=${localStorage.getItem('DP_PROJECT_ID')}`,{
      // responseType: "blob"
    });
    return response.data;
  } catch (e) {
    console.log("ERROR", e);
  }
};

export const createTermsOfUse = async (payload: any) => {
  try {
    const tenantId = getCookies("tenant-id");
    const response = await axios.post(`/tenants/${tenantId}/terms-of-use?project_id=${localStorage.getItem('DP_PROJECT_ID')}`,
      payload,
    );
    return response.data.data;
  } catch (e) {
    console.log("ERROR", e);
  }
};

export const updateTerms = async ({ id, ...payload }: any,) => {
  try {
    const tenantId = getCookies("tenant-id");
    const response = await axios.put(`/tenants/${tenantId}/terms-of-use/${id}?project_id=${localStorage.getItem('DP_PROJECT_ID')}`,
      payload,
    );
    return response.data.data;
  } catch (e) {
    console.log("ERROR", e);
  }
};

export const removeTerms = async (policyId: number) => {
  try {
    const tenantId = getCookies("tenant-id");
    const response = await axios.delete(`/tenants/${tenantId}/terms-of-use/${policyId}?project_id=${localStorage.getItem('DP_PROJECT_ID')}`);
    return response.data.data;
  } catch (e) {
    console.log("ERROR", e);
  }
};
